export const PREFIX_OPTIONS = [
  { label: "CGI", value: "CGI" },
  { label: "AIS", value: "AIS" },
  { label: "GTO", value: "GTO" },
];